/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_add_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M5 5h5.5M5 8h8.5M5 19h3.5m10-10V7.866a1 1 0 0 0-.237-.646L13.3 1.354A1 1 0 0 0 12.536 1H2.5a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1H11m6.6-2.9v-5m2.5 2.5h-5m8.125 0a5.625 5.625 0 1 1-11.25 0 5.625 5.625 0 0 1 11.25 0Z"
    />
  </svg>
)
export default file_add_medium
